function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M43.75 19.285v1.107a5.535 5.535 0 005.536 5.536 5.535 5.535 0 005.535-5.536v-5.086a4.879 4.879 0 00-4.878-4.878h-.657c-3.322 0-6.643-2.214-6.643-2.214s-1.107 1.107-1.107 3.321c0 3.322 2.214 5.536 5.535 5.536M43.75 20.393v-4.27M45.964 29.25s1.108 1.107 3.322 1.107 3.321-1.107 3.321-1.107",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.929 31.464v-4.07",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.715 40.32s-1.107 1.108-3.322 1.108c-2.214 0-3.321-1.107-3.321-1.107M67 44.75H29.994M24.928 30.357v1.107A5.535 5.535 0 0119.393 37a5.535 5.535 0 01-5.536-5.536v-5.086a4.879 4.879 0 014.878-4.878H24.928c1.223 0 2.214.992 2.214 2.214 0 2.7-2.214 4.429-5.535 4.429M28.25 50.286V68M34.203 52.566l4.076-2.881a2.767 2.767 0 013.494 4.276l-5.708 5.383a3.313 3.313 0 01-2.28.906c-.784 0-1.504-.28-2.076-.73l-3.459-2.73",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.256 54.523l-5.633-10.465a4.537 4.537 0 00-2.446-2.114l-4.463-1.623v-4.428M24.046 67.81l-7.04-19.594a8.585 8.585 0 00-8.077-5.68H5",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.76 42.735l.962-.717a6.782 6.782 0 012.206-1.088l2.144-.609v-4.428M38.627 56.928H67M64.25 44.75l-3.957-10.517a6.212 6.212 0 00-3.85-3.705l-3.836-1.279v-4.428M46.466 44.75l-3.093-9.852a3.323 3.323 0 00-3.17-2.327H28.25M45.964 24.82v4.43l-2.164.618a5.572 5.572 0 00-1.826.91l-2.376 1.793",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M45.075 40.32h8.64a3.322 3.322 0 013.32 3.322c0 .612-.494 1.107-1.107 1.107",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.291 20.3l-4.715-3.229H19.393a2.215 2.215 0 01-2.214-2.214V8.214c0-1.222.992-2.214 2.214-2.214h15.5c1.222 0 2.214.992 2.214 2.214V19.87c0 .42-.47.668-.816.43z",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M31.572 11.679a.143.143 0 110-.286.143.143 0 010 .286zM27.143 11.679a.143.143 0 110-.286.143.143 0 010 .286zM22.714 11.679a.143.143 0 110-.286.143.143 0 010 .286z",
  fill: "#4D4D4D",
  stroke: "#4D4D4D",
  strokeWidth: 2.5
});

function SvgComplexSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default __webpack_public_path__ + "/img/complex-support.svg";
export { SvgComplexSupport as ReactComponent };